import type { ReactNode } from "react";
import { DESIGN_TOKENS, SIZE_STYLES } from "@/constants";
import { cn } from "@/utils";
import StatusDot from "./StatusDot";

interface SectionHeaderProps {
  title: ReactNode;
  extra?: ReactNode;
  size?: "sm" | "md" | "lg";
  className?: string;
  dotColor?: string;
}

export default function SectionHeader({
  title,
  extra,
  size = "md",
  className = "",
  dotColor,
}: SectionHeaderProps) {
  const currentSize = SIZE_STYLES[size];

  const headerClasses = cn(
    "flex items-center justify-between",
    "border-b-2",
    DESIGN_TOKENS.colors.border.secondary,
    currentSize.header,
    DESIGN_TOKENS.colors.bg.header,
    "backdrop-blur-sm",
    "rounded-t-xl",
    className
  );

  return (
    <div className={headerClasses}>
      {title && (
        <div
          className={`font-bold ${DESIGN_TOKENS.colors.text.primary} flex items-center gap-2`}
        >
          <StatusDot
            {...(dotColor && { color: dotColor })}
            ariaLabel="Section header indicator"
          />
          {title}
        </div>
      )}
      {extra && <div className={DESIGN_TOKENS.colors.text.muted}>{extra}</div>}
    </div>
  );
}
